import { render } from "./quickReply.vue?vue&type=template&id=1b1ee3d0"
import script from "./quickReply.vue?vue&type=script&lang=js"
export * from "./quickReply.vue?vue&type=script&lang=js"

import "./quickReply.vue?vue&type=style&index=0&id=1b1ee3d0&lang=scss"

import exportComponent from "C:\\Users\\pzx\\Desktop\\Master\\im\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__